import {Component, Inject, OnInit, ViewChild, signal} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';
import { N_MODULE } from '../../../../config/config';

 
@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})



export class AddMasterProductComponent implements OnInit{ 
 
  cat: any;
  searchTxt: null;

 constructor(public dialogRef: MatDialogRef<AddMasterProductComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private masterdataService: MasterdataService ) {
  if (data) {
    this.editOb = data;
    this.formData = this.editOb.item; 
  }
 }

  ngOnInit(): void {
    // I'm using same component for both add and edit product
    if(this.formData){
      this.nameTxt = this.formData.name;
      this.isEdited = true;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  

  public formData: any;

  responseData: any = {};
  public fileType = "";
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = "";

  public isEdited: boolean = false;

  public editOb: any;

  public nameTxt: any;
  public dragTxt: any;
  public file: any;
  public search: any;

  changedStoreType: any = {
    type: "", value: ""
  };
  // displayedStoreType: string = '';
  public isDragOver = signal(false);

  public changedStoreName: string;
  public storeNames: any = [];

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput = document.getElementById("file-input-add");
    fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes = ['png', 'jpg'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function() {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function() {
      toastContainer.classList.remove('show');
    }, 5000);
  }



  onAdd(){
    let data ={
      name:this.nameTxt,
    }
    if(this.isEdited){
      this.masterdataService.masterEditBody('regions', this.formData.id, data).subscribe((res:any)=>{
        this.onClose();
      });
    }else{
      this.masterdataService.masterAddItem('regions',data).subscribe((res:any)=>{
        this.onClose();
      });
    }
  }


}
